(function($) {
	"use strict";

	jQuery(document).ready(function(){

                
	       var $window_2 = $(window);
      $window_2.on('scroll', function () {
        var scroll = $window_2.scrollTop();
        if (scroll < 500) {
          $(".product-addtocart-sticky").removeClass("is-sticky-2");
        } else {
          $(".product-addtocart-sticky").addClass("is-sticky-2");
        }
      });

	/*--------------------------
	3. Category Menu Active
	---------------------------- */	
	$('.rx-parent').on('click', function(){
	$('.rx-child').slideToggle();
	$(this).toggleClass('rx-change');
	});
	$(".embed-responsive iframe").addClass("embed-responsive-item");
	$(".carousel-inner .item:first-child").addClass("active");
	//    category heading
	$('.category-heading').on('click', function(){
	$('.category-menu-list').slideToggle(300);
	});	    

	/*==================================
	6. Slick Slider Active
	====================================*/

	/*----------------------------------- 
	6.4 Slide Active Home 2
	----------------------------------*/   
	$('.slide-active-home-2').slick({
		slidesToShow: 1,
		prevArrow: '<i class="fa fa-angle-left"></i>',
		nextArrow: '<i class="fa fa-angle-right slick-next-btn"></i>',
	});

	/*----------------------------------- 
	7. Count Down Active 
	----------------------------------*/ 
	$('[data-countdown]').each(function() {
	var $this = $(this), finalDate = $(this).data('countdown');
	$this.countdown(finalDate, function(event) {
		$this.html(event.strftime('<div class="single-count"><span>%D</span>Days</div><div class="single-count"><span>%H</span>Hours</div><div class="single-count"><span>%M</span>Mins</div><div class="single-count"><span>%S</span>Secs</div>'));
	});
	});
	/*---------------------------------
	8. Tooltip Active
	-----------------------------------*/
	$('.product-action a,.product-price a,.socil-icon li a,.blog-social-icon li a').tooltip({
		animated: 'fade',
		placement: 'top',
		container: 'body'
	});
	/*----------------------------------
	9. ScrollUp Active
	-----------------------------------*/
	$.scrollUp({
	scrollText: '<i class="ion-chevron-up"></i>',
	easingType: 'linear',
	scrollSpeed: 900,
	animation: 'fade'
	});
	/*--------------------------
	10. Counter Up
	---------------------------- */
	$('.counter').counterUp({
		delay: 70,
		time: 5000
	});
	/* ---------------------------
	11. FAQ Accordion Active
	* ---------------------------*/ 
	$('.panel-heading a').on('click', function() {
	$('.panel-default').removeClass('active');
	$(this).parents('.panel-default').addClass('active');
	});
	/*--------------------------
	12.  Wow Active
	---------------------------- */    
	new WOW().init();
	/*--------------------------
	13. Isotope Active
	---------------------------- */
	$('.protfolio-active').imagesLoaded( function() {
	// images have loaded
	// init Isotope
	var $grid = $('.protfolio-active').isotope({
	  // options
	});
	// filter items on button click
	$('.protfolio-menu-active').on( 'click', 'li', function() {
	  var filterValue = $(this).attr('data-filter');
	  $grid.isotope({ filter: filterValue });

		  $(this).siblings('.active').removeClass('active');
		  $(this).addClass('active');
		  event.preventDefault();
	});
	});

	/*==================================
	15. All Toggle Active
	====================================*/
	/*---------------------------------
	15.1 Showlogin Toggle Function
	-----------------------------------*/
	$( '#showlogin' ).on('click', function() {
	$( '#checkout-login' ).slideToggle(900);
	});    
	/*----------------------------------
	15.2 Showcoupon Toggle Function
	------------------------------------*/
	$( '#showcoupon' ).on('click', function() {
	$( '#checkout_coupon' ).slideToggle(600);
	});
	/*------------------------------------------
	15.3 Create An Account Toggle Function
	--------------------------------------------*/
	$( '#cbox' ).on('click', function() {
	$( '#cbox_info' ).slideToggle(900);
	});
	/*------------------------------------------
	15.4 Create An Account Toggle Function
	---------------------------------------------*/
	$( '#ship-box' ).on('click', function() {
	$( '#ship-box-info' ).slideToggle(1000);
	});

	/*----------------------------------
	16. Chosen Active 
	------------------------------------*/
	$(".chosen-select").chosen({disable_search_threshold: 10});


    /* Remove Attr  */
      
    $('a.tile-actions--btn').removeAttr('href');
       $('span.our-blog-author a').removeAttr('href');
      	
    /* Ajax Cart */
      
    $(".cart-item").on('click', function(){
      $(this).addClass("loading add-item");
      setTimeout(function () {
        $(".cart-item").removeClass("loading");
      },700);
      setTimeout(function () {
        $(".cart-item").removeClass("add-item");
      },1500);

    });  

      
        $(".cart-plus-minus").prepend('<div class="dec qtybutton">-</div>');
  $(".cart-plus-minus").append('<div class="inc qtybutton">+</div>');
  $(".qtybutton").on("click", function() {
    var $button = $(this);
    var oldValue = $button.parent().find("input").val();
    if ($button.text() == "+") {
      var newVal = parseFloat(oldValue) + 1;
    } else {
      // Don't allow decrementing below zero
      if (oldValue > 0) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 1;
      }
    }
    $button.parent().find("input").val(newVal);
  });

      
      
	/* preloader */
	$(window).on('load', function() {
	  $('#preloader_active').fadeOut('slow');
	}); 
	  
	  
	/* Match Heigh */ 
		$('.item').matchHeight();
      
  

	  
	});

})(jQuery);



